import styled, { css } from 'styled-components';
import { Link } from 'react-router';

const styles = css`
  color: inherit;
  text-decoration: none;
  display: block;
  padding: 8px;
`;

const BlockLink = styled(Link)`
  ${styles}
`;

export const AnchorBlockLink = styled.a`
  ${styles}
`;

export default BlockLink;
